import { useState } from 'react'
import { useLocation } from 'wouter'
import { ChevronLeft, Sun, Moon, Star, BedDouble } from 'lucide-react'
import ConfirmModal from '@/components/common/ConfirmationModal'

const reservationOptions = [
	{
		id: 'day',
		title: 'VIP Day Pool Cabanas',
		description: 'Reserve a cabana at the day pool',
		icon: Sun,
		href: '/reservations/day',
	},
	{
		id: 'night',
		title: 'VIP Night Pool Cabanas',
		description: 'Reserve a cabana at the night pool',
		icon: Moon,
		href: '/reservations/night',
	},
	{
		id: 'club',
		title: 'VIP Club Reservations',
		description: 'Reserve your spot at the club',
		icon: Star,
		href: '/reservations/club',
	},
	{
		id: 'room',
		title: 'Make Room Reservation',
		description: 'Book a room at Secrets Hideaway',
		icon: BedDouble,
		href: null,
	},
]

export default function CabanasPage() {
	const [, navigate] = useLocation()
	const [showBookingConfirm, setShowBookingConfirm] = useState(false)

	function handleOptionClick(option: typeof reservationOptions[number]) {
		if (option.id === 'room') {
			setShowBookingConfirm(true)
		} else {
			navigate(option.href!)
		}
	}

	return (
		<div className="min-h-auto bg-[#18181B] h-full">
			<div className="max-w-5xl mx-auto px-5 pb-8 flex flex-col" style={{ minHeight: 'calc(100vh - 54px)' }}>
				{/* Header */}
				<div
					role="banner"
					className="sticky top-0 z-10 flex items-center gap-3 py-3 bg-[#18181B] backdrop-blur-md"
				>
					<button
						onClick={() => navigate('/')}
						className="h-8 w-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/40"
					>
						<ChevronLeft className="h-[22px] w-[22px] text-[#ffffff]" />
					</button>
					<h1 className="text-[20px] leading-[18px] font-bold font-montserrat tracking-wide text-white">
						Reservations
					</h1>
				</div>

				{/* Content */}
				<div className="flex items-center justify-center flex-1">
					<div className="grid gap-4 w-full">
						{reservationOptions.map((option) => (
							<button
								key={option.id}
								onClick={() => handleOptionClick(option)}
								className="w-full bg-[#212124] hover:bg-[#2a2a2d] border border-white/5 rounded-2xl p-6 text-left transition-all duration-200 active:scale-[0.98] group"
							>
								<div className="flex items-center gap-4">
									<div className="h-14 w-14 rounded-full bg-[#EF4444]/10 flex items-center justify-center shrink-0">
										<option.icon className="h-7 w-7 text-[#EF4444]" />
									</div>
									<div className="flex-1 min-w-0">
										<h2 className="text-white font-semibold text-base font-montserrat mb-1">
											{option.title}
										</h2>
										<p className="text-[#BABABB] text-sm font-figtree">
											{option.description}
										</p>
									</div>
									<ChevronLeft className="h-5 w-5 text-[#BABABB] rotate-180 group-hover:translate-x-0.5 transition-transform" />
								</div>
							</button>
						))}
					</div>
				</div>
			</div>

			<ConfirmModal
				open={showBookingConfirm}
				onClose={() => setShowBookingConfirm(false)}
				onConfirm={() => {
					setShowBookingConfirm(false)
					window.open('https://www.secretsfl.com/book-now-iframe', '_blank')
				}}
				title="You're leaving the app"
				description="You will be redirected to the Secrets Hideaway website to complete your room booking. The booking site's terms and policies will apply."
				confirmText="Continue to Booking"
				cancelText="Stay in SECH"
			/>
		</div>
	)
}
